  /* begin wholesale checkout */

  $(function() {
    var invoice_url;

    function isJSON(str) {
      try {
          return (JSON.parse(str) && !!str);
      } catch (e) {
          return false;
      }
    }

    // change address selection to "Add New" if user makes changes to the address form
    function draft_order_address_change() {
      $('.js-customer-address-dropdown').prop('selectedIndex', 1);
      $('.js-customer-address').removeClass('selected');
      $(window).trigger('customerAddressSelection');
    }


    $(document.body).on('keydown', '.js-draft-order-add-address input', function() {
      draft_order_address_change();
    });
    $(document.body).on('change', '.js-draft-order-add-address input', function() {
      draft_order_address_change();
    });
    $(document.body).on('change', '.js-draft-order-add-address select', function() {
      draft_order_address_change();
    });

    function validate_shipping() {
      function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $('.js-draft-order-add-address')
        .filter(':visible')
        .find('input, select, textarea')
        .filter('[data-required]')
        .each(function() {
          var input = this;
          var $input = $(input);

          var error = false;

          if( (! input.value) || input.value == $input.attr('placeholder') ) {
            error = 'Required field.';
          }
          if ( input.name.indexOf('email') > -1 && !validateEmail(input.value) ) {
            error = 'Invalid email.';
          }

          if( error ) {
            $(input).addClass('form-input-error! js-form-input-error');
            $('.js-error-address-requireds').show();
          } else {
            $(input).removeClass('form-input-error!').removeClass('js-form-input-error');
            $('.js-error-address-requireds').hide();
          }
        });

      console.log($('.js-draft-order-add-address').filter(':visible').find('.js-form-input-error').filter(':visible').length);
      console.log($('.js-draft-order-add-address').filter(':visible').find('.js-form-input-error').filter(':visible'));
      if ($('.js-draft-order-add-address').filter(':visible').find('.js-form-input-error').filter(':visible').length == 0) {
        return true;
      } else {
        return false;
      }
    }

    function clear_cart_then_redirect() {
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        dataType: 'json',
        success: function(data, textStatus, jqXHR) {
          window.location = "https://archie-mcphee-wholesale.myshopify.com/pages/draft-order-success";
        }
      });
    }

    // disable button immediately after submitting so we can't get duplicate submissions.
    var submitting = false;

    // keep
    function submit_draft_order() {
      var validated = validate_shipping();
      if (validated && submitting == false) {
        submitting = true;
        $.ajax({
          // url: "https://localhost/shopifycustom/apiclient/endpoint/create_draft_order.php",
          url: "https://dev.mcphee.com/endpoint/create_draft_order.php",
          dataType: "json",
          data: draft_order_payload,
          type: "POST",
          success: function(data, textStatus, jqXHR) {
            clear_cart_then_redirect(); // to clear or not?
            invoice_url = data.draft_order.invoice_url;

            // re-enable buttons after submitting
            submitting = false;
            $('.js-submit-draft-order').attr('disabled', false);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            alert(errorThrown + "\r\n" + jqXHR.statusText + "\r\n" + jqXHR.responseText);
            console.log("error with draft_order_payload on create_draft_order submit", draft_order_payload);
            // re-enable buttons after submitting
            submitting = false;
            $('.js-submit-draft-order').attr('disabled', false);
          },
          complete: function(jqXHR, textStatus) {
          }
        });
      }

    }

    $(document.body).on('click', '.js-submit-draft-order', function(e) {
      e.preventDefault();

      var index = $('.js-customer-address-dropdown').find('option').filter(':checked').index() - 2; // -1 for select an address and -1 for add new

      if (index == -2) {
        $('.js-error-no-address-selected').show();
        return false;
      }

      if ($(this).hasClass('js-proceed-to-checkout')) {
        window.location = invoice_url;
      } else {
        submit_draft_order();
      }
    });

    // keep
    $('[name="note"]').on('keyup', function() {
      draft_order_payload.cart_order.note = $(this).val();
    });

    // get the selected address, or new address option
    $(document.body).on('change', '.js-customer-address-dropdown', function() {
      var index = $(this).find('option').filter(':checked').index() - 2; // -1 for select an address and -1 for add new

      // show the address form, will populate if applicable
      $('.js-draft-order-add-address').show();


      if (index >= 0) {
        $('.js-customer-address').filter(':visible').removeClass('selected');
        $('.js-customer-address').filter(':visible').eq(index).addClass('selected');

        $(window).trigger('customerAddressSelection');
      } else if (index == -1) {
        // new address, we'll just leave it blank for the user to fill in

        $('.js-draft-order-add-address [data-json-key]').val('');
      }

      // $('#address_country_new').filter(":visible")[0].dispatchEvent(new Event('change'));
      // draft_order_payload.cart_order.customer.default_address.province = $('#address_province_new').val();
    });

    $(window).on('customerAddressSelection', function (event) {
      $('#address_province_container_new').find('select').attr('data-json-key', 'province');

      // stick with default first
      var address = draft_order_payload.cart_order.customer.default_address;

      var selected_index = $('.js-customer-address-dropdown').find('option').filter(':checked').index() - 2;
      var $selected_address = $('[data-address-json]').eq(selected_index);


      if (selected_index >= 0 && $selected_address.length > 0) {
        var address_json_string = $selected_address.text();
        // console.log(address_json_string);
        address = JSON.parse(address_json_string);
        // console.log(address);
        // I need province to be last to trigger the Shopify provinces script properly...
        province = address.province;
        delete address.province;
        address.province = province;

        // fill the form with the saved address values
        for (var key in address) {
          if (address.hasOwnProperty(key)) {
            var value = address[key];
            var selector = '.js-draft-order-add-address [data-json-key="' + key + '"]';
            $(selector).val(value);
            if (key == "country") {
              $('#address_country_new').filter(":visible")[0].dispatchEvent(new Event('change'));
            }
          }
        }
      }

      var $address_form = $('.js-draft-order-add-address').filter(":visible"); 

      if ($address_form.length) {
        // fill the data object with form values

        var $inputs = $address_form.find('[data-json-key]');
        address = {};
        $inputs.each(function() {
          var key = $(this).attr('data-json-key');
          var value = $(this).val();
          address[key] = value;
        });
      }

      draft_order_payload.cart_order.customer.default_address = address;
    });

    /* end wholesale checkout */
  });
